<h2 mat-dialog-title class="dialog-title">
  Business Rule on feature {{ data.feature }}
</h2>

<mat-dialog-content class="dialog-content">
  <form [formGroup]="form">

    <div class="form-row" style="margin-top: 16px; width:70%;">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Select business rules</mat-label>
        <mat-select formControlName="businessRule">
          <mat-option *ngFor="let rule of businessRules" [value]="rule">{{
            rule
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      class="form-row"
      style="margin-top: 16px; width: 70%; flex-direction: column"
    >
      <mat-radio-group formControlName="mode" class="vertical-radio">
        <mat-radio-button value="Assert">Assert</mat-radio-button>
        <mat-radio-button value="Report">Report</mat-radio-button>
      </mat-radio-group>
    </div>
  
    <div class="form-row" style="margin-top: 16px; width: 70%;">
      <mat-form-field class="underline-only" appearance="fill" style="flex: 1">
        <mat-label>Business Rule </mat-label>
        <textarea
          matInput
          formControlName="businessRuleDescription"
          rows="4"
          placeholder="Enter the Schematron rule here..."
        ></textarea>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-raised-button color="primary" (click)="onClose()">Save</button>
  <button mat-raised-button color="primary" (click)="onLock()">Cancel</button>
</mat-dialog-actions>
